














 import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';

export default Vue.extend({
  name: 'Footer',
  computed: {
    ...mapGetters(['isFeatureFlagEnabled']),
    ...mapState({
      currentFeatures: (s: any) => s.FeatureFlagModule.currentFeatures,
    }),
    applyNaluRebrand() {
      return this.isFeatureFlagEnabled(this.currentFeatures.applyNaluRebrand);
    },
  },
});
